import { useCallback, useEffect, useRef, useState } from "react";

// Houdt het teamtotaal (meter, bedragen, balk) op de oude stand tot het geld ook in beeld
// binnenkomt: als de meter veert (gauge-pulse; bij Film landt het bedrag dan in de meter),
// als de meter naar 100 gaat, of als "Verkopen gemist" het laat zien. Speelt er niets, dan
// na settleMs rust alsnog. Minder dan wat er staat (nieuwe maand, correctie) of een lege
// meter bij het opstarten gaat meteen. settle(data): meteen tonen (voor het lab).

const settleMs = 1500;
const arrivalIds = ["gauge-pulse", "target-charge", "missed-sales"];

const totalsOf = (data) => ({
  amount: data.amount,
  scoredTowardsTarget: data.scoredTowardsTarget,
  teamTarget: data.teamTarget,
});

const higher = (next, shown) =>
  (next.amount || 0) > (shown.amount || 0) ||
  (next.scoredTowardsTarget || 0) > (shown.scoredTowardsTarget || 0);

export function useHeldTeam(data, active) {
  const shown = useRef(totalsOf(data));
  const release = useRef(false);
  const [, rerender] = useState(0);

  const next = totalsOf(data);
  const empty = !shown.current.amount;
  const arrived = active.some((run) => arrivalIds.includes(run.id));
  // Hetzelfde target (tekst of bedrag) moet wel meteen mee.
  const sameTarget = next.teamTarget?.amount === shown.current.teamTarget?.amount;

  if (!higher(next, shown.current) || !sameTarget || empty || arrived || release.current) {
    shown.current = next;
    release.current = false;
  }

  const settle = useCallback((fresh) => {
    shown.current = totalsOf(fresh);
    release.current = false;
    rerender((count) => count + 1);
  }, []);

  const holding = shown.current !== next;
  const idle = active.length === 0;

  useEffect(() => {
    if (!holding || !idle) return undefined;
    const timer = setTimeout(() => {
      release.current = true;
      rerender((count) => count + 1);
    }, settleMs);
    return () => clearTimeout(timer);
  }, [holding, idle]);

  return { ...shown.current, settle };
}
